var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"row align-center tab-content"},_vm._l((_vm.list),function(item,index){return _c('div',{key:item.id,class:['tab-item', _vm.curIndex == item.id ? 'select-item' : ''],on:{"click":function($event){return _vm.changeTabs(item.id, index)}}},[_c('span',[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }